import { cn } from '@/lib';

export type Step = { key: string; label: string };

type StepperProps = {
  steps: Step[];
  activeIndex: number;
  maxEnabledIndex?: number;
  onStepClick?: (index: number) => void;
};

export function Stepper({ steps, activeIndex, maxEnabledIndex = activeIndex, onStepClick }: StepperProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2">
        {steps.map((s, i) => {
          const done = i < activeIndex;
          const active = i === activeIndex;
          const enabled = i <= maxEnabledIndex;
          return (
            <div key={s.key} className="flex flex-1 items-center gap-2">
              <button
                type="button"
                onClick={() => enabled && onStepClick?.(i)}
                disabled={!enabled}
                className={cn(
                  'group flex items-center gap-2 text-left disabled:cursor-not-allowed',
                  enabled ? 'cursor-pointer' : 'cursor-not-allowed',
                )}
              >
                <div
                  className={cn(
                    'flex h-8 w-8 items-center justify-center rounded-full border text-sm font-semibold',
                    done && 'bg-primary text-primary-foreground border-primary',
                    active && 'border-primary',
                    !done && !active && 'text-muted-foreground',
                    enabled && 'group-hover:border-primary',
                  )}
                >
                  {i + 1}
                </div>
                <div className={cn('text-sm', active ? 'font-medium' : 'text-muted-foreground')}>{s.label}</div>
              </button>
              {i !== steps.length - 1 && <div className="bg-border h-px flex-1" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
